import React from 'react';
import UnifiedDashboard from './pages/UnifiedDashboard';
// import Login from './components/Login';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* <Login /> */}
      <UnifiedDashboard />
    </div>
  );
}

export default App;